import React, { useEffect, useRef, useState } from "react";
import styles from "./formCategory.module.css";
import Grid from "@mui/material/Grid";
import { Typography } from "@mui/material";
import TextField from "component/textField/TextField";
import { format } from "date-fns";
import AppBackdrop from "component/appBackdrop/AppBackdrop";
import SignatureField from "component/signatureField/SignatureField";
import ValidationMessage from "component/validationMessage/ValidationMessage";
import sig_icon from "assets/images/signature.svg";
import write_icon from "assets/images/write.svg";
import AppDatePicker from "component/inputs/datePicker/DatePicker";

function CoApplicantSignature({trigger, watch, application, setValue, formData, errors, register }) {
  const [openSignaturePad, setOpenSignaturePad] = useState(false);
  const sigCanvas = useRef();
  const [base64imageURL, setBase64ImageURL] = useState(null);
  const signatureName = watch("coSignatureName", "");
  const coSignDate = watch('coSignDate', '')

  useEffect(()=>{
    setBase64ImageURL(application.coSignature)
  }, [application])

  useEffect(()=>{
    setValue('coSignDate', new Date())
  }, [])

   

   useEffect(()=>{
    setValue('coSignature', base64imageURL)
  }, [base64imageURL])


  return (
    <div className={styles.category_tab}>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={4}>
          <div className={styles.category}>
            <Typography variant="h6">Co-applicant’s E-Signature</Typography>
            <Typography>
              Please Sign and Append date so as to complete your Mortgage
              Application
            </Typography>
          </div>
        </Grid>
        <Grid item xs={12} sm={8}>
          <div className={styles.category_form}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                <AppDatePicker
                    required={true}
                    errors={errors}
                    name="coSignDate"
                    label="Date"
                    setValue={setValue}
                    value={coSignDate}
                    trigger={trigger}
                  />
              
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                <div className={styles.signature}>
                    <Typography>Signature / Full Name <span style={{color: 'red'}} >*</span></Typography>
                    <div
                      onClick={() => {
                        setOpenSignaturePad(true);
                      }}
                      className={styles.sign_pad}
                    >
                      {signatureName ? (
                        <div>
                          <Typography>{formData.coSignatureName}</Typography>

                          <div className={styles.sig_img}>
                            <img src={base64imageURL} alt="signature" />
                          </div>
                        </div>
                      ) : (
                        <>
                          <div>
                            <Typography>Sign Here </Typography>
                            <div>
                              <img src={sig_icon} alt="" />
                            </div>
                          </div>
                          <div>
                            <img src={write_icon} alt="" />
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                  {errors.coSignatureName && <ValidationMessage message={errors?.coSignatureName?.message} />}
                 
                </div>
              </Grid>
            </Grid>
          </div>
        </Grid>
      </Grid>
      {
        <AppBackdrop
          openModal={openSignaturePad}
          children={
            <SignatureField
            signatureName={'coSignature'}
            name='coSignatureName'
            errors={errors}
            trigger={trigger}
            setValue={setValue}
              handleCloseField={() => {
                setOpenSignaturePad(false);
                trigger('coSignatureName')
              
              }}
              setImageURL={setBase64ImageURL}
              sigCanvas={sigCanvas}
            />
          }
        />
      }
    </div>
  );
}

export default CoApplicantSignature;